export const getEndDecorator = (priceRepresentation, field, currency) => {
  if (priceRepresentation === 'Q' || priceRepresentation === 'C') return ' %';

  if (
    priceRepresentation === 'P' &&
    field !== 'price' &&
    field !== 'stopPx' &&
    field !== 'avgPx' &&
    field !== 'lastPx'
  )
    return ` ${currency}`;

  return null;
};

export const getPercentageDecorator = (priceRepresentation) =>
  (priceRepresentation === 'Q' || priceRepresentation === 'C') && ' %';

export const getPublicOfferPriceEndDecorator = (priceType, typeNegotiation) => {
  if ((priceType === 'Q' && typeNegotiation !== 'Q') || priceType === 'T')
    return ' %';

  return null;
};
